export const FLAG_SHOP_ONLINE_VIDEOS = "shop-online-videos";
export const FLAG_ZITADEL_AZURE_LOGIN = "zitadel-azure-login";
export const FLAG_ZITADEL_GOOGLE_LOGIN = "zitadel-google-login";
